module.exports = __webpack_public_path__ + "img/ic24Key.03d58ec4.svg";